<template>
  <div :class="['spinner-container', { inline, light }]">
    <span class="spinner" :style="{ width: `${this.size}px`, height: `${this.size}px` }" />
  </div>
</template>

<script>
export default {
  props: {
    inline: Boolean,
    light: Boolean,
    size: {
      type: String,
      default: '40',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner {
  border-radius: 50%;
  display: inline-block;
  transform: translateZ(0);
  animation: spin 1s infinite linear;
  border-top: 3px solid $color-green-1;
  border-right: 3px solid $color-green-1;
  border-bottom: 3px solid $color-green-1;
  border-left: 3px solid transparent;
}

.spinner-container {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  opacity: .8;
  position: absolute;
  right: 0;
  top: 0;

  &.inline {
    display: inline-block;
    position: static;
  }

  &.light {
    .spinner {
      border-top-color: $color-white;
      border-right-color: $color-white;
      border-bottom-color: $color-white;
    }
  }
}
</style>
